/** À charger après CSS_ADMIN. La classe de l'espace est pilotée par l'état serveur. */
export const CSS_DEMO_EASTER_EGG = `
/* Les couleurs de la surprise ne s'appliquent pas aux impressions. */
@media screen {
  .ux-portail--arc-en-ciel {
    --admin-primaire: #66349A;
    --admin-fonce: #4B2377;
    --admin-accent: #F1E6FF;
    --admin-ligne: #DDD2EB;
    --funo-framboise: #66349A;
    --funo-ligne: #DDD2EB;
    background:
      radial-gradient(ellipse at 92% 4%, #E2EFFF 0, transparent 32rem),
      radial-gradient(ellipse at 6% 88%, #E2F4E8 0, transparent 34rem),
      #FFF9F4;
  }
  .ux-portail--arc-en-ciel .admin__lateral {
    background: linear-gradient(165deg, #FCE4EF, #FFF1DB 35%, #E4F4E8 65%, #E9E8FF);
    border-color: #D8C9E4;
  }
  .ux-portail--arc-en-ciel .admin__barre {
    background: linear-gradient(100deg, #FFF4F9, #FFF9E6 38%, #EDF8F5 68%, #EEF0FF);
    border-color: #DDD2EB;
  }
  .ux-portail--arc-en-ciel .ux-nav-entree { --demo-teinte: #F9DCEC; }
  .ux-portail--arc-en-ciel .ux-nav-entree:nth-of-type(6n + 2) { --demo-teinte: #FFE8CE; }
  .ux-portail--arc-en-ciel .ux-nav-entree:nth-of-type(6n + 3) { --demo-teinte: #FFF1B8; }
  .ux-portail--arc-en-ciel .ux-nav-entree:nth-of-type(6n + 4) { --demo-teinte: #D9EFE1; }
  .ux-portail--arc-en-ciel .ux-nav-entree:nth-of-type(6n + 5) { --demo-teinte: #DDEBFF; }
  .ux-portail--arc-en-ciel .ux-nav-entree:nth-of-type(6n + 6) { --demo-teinte: #EADFFD; }
  .ux-portail--arc-en-ciel .ux-nav-entree > button {
    background: var(--demo-teinte);
    color: #3D2647;
    border-color: #FFFFFFA6;
  }
  .ux-portail--arc-en-ciel .ux-nav-entree > button:hover {
    border-color: #866899;
  }
  .ux-portail--arc-en-ciel .ux-nav-entree > button[aria-current="page"] {
    color: #43235D;
    border-color: #66349A;
    box-shadow: inset 3px 0 0 #66349A;
  }
  .ux-portail--arc-en-ciel :is(.admin__panneau, .admin__carte, .ac-panel, .ev-carte) {
    border-color: #DCCCEB;
    box-shadow: 0 5px 22px #66349A0A;
  }
  .ux-portail--arc-en-ciel .admin__panneau > .admin__section-entete {
    background: linear-gradient(110deg, #FFF0F6, #F3EDFF 55%, #EAF5FF);
  }
  .ux-portail--arc-en-ciel .ux-resume .admin__stat {
    background: #FBE5EE;
    border: 1px solid #EBCEDB;
    border-radius: 14px;
    padding: 16px;
  }
  .ux-portail--arc-en-ciel .ux-resume .admin__stat:nth-child(3n + 2) {
    background: #FFF1D6;
    border-color: #EBDAB6;
  }
  .ux-portail--arc-en-ciel .ux-resume .admin__stat:nth-child(3n + 3) {
    background: #E3F0FC;
    border-color: #CCDFEF;
  }
  .ux-portail--arc-en-ciel .ux-prochaine-etape {
    background: linear-gradient(140deg, #F9E2EF, #FFF1D6 48%, #E3F2EA);
    border-color: #DCCCEB;
  }
  .ux-portail--arc-en-ciel :is(.admin__primaire, .ac-button.primary, .ev-primaire) {
    color: #FFF;
    background: linear-gradient(110deg, #913561, #66349A 54%, #305F99);
    border-color: #66349A;
  }
  .ux-portail--arc-en-ciel :is(.admin__primaire, .ac-button.primary, .ev-primaire):hover:not(:disabled) {
    background: linear-gradient(110deg, #772A50, #4B2377 54%, #254B7C);
    border-color: #4B2377;
    box-shadow: 0 4px 12px #66349A26;
  }
  .ux-portail--arc-en-ciel .ux-vignette { background: #E8DDF9; color: #66349A; }
  .ux-portail--arc-en-ciel .ux-vignette--1 { background: #FFEBCA; color: #755126; }
  .ux-portail--arc-en-ciel .ux-vignette--2 { background: #DDECFD; color: #305F99; }
  .ux-portail--arc-en-ciel :is(button, a, summary, input, select, textarea, [tabindex]):focus-visible {
    outline-color: #4B2377;
  }
  .ux-portail--arc-en-ciel .ux-demo-easter-egg {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px 24px;
    padding: 20px 22px;
    margin: 0 0 26px;
    border: 1px solid #DCC9E8;
    border-radius: 16px;
    color: #3D2647;
    background: linear-gradient(115deg, #FBE3EE, #FFF1D6 35%, #E3F2E8 65%, #E8E4FF);
    box-shadow: 0 5px 22px #66349A0A;
  }
  .ux-portail--arc-en-ciel .ux-demo-easter-egg__texte { flex: 1 1 300px; min-width: 0; }
  .ux-portail--arc-en-ciel .ux-demo-easter-egg__titre {
    color: #3D2647;
    font-size: 16px;
    font-weight: 800;
    line-height: 1.45;
    margin: 0 0 5px;
  }
  .ux-portail--arc-en-ciel .ux-demo-easter-egg__description {
    color: #58435F;
    font-size: 13px;
    margin: 0;
  }
  .ux-portail--arc-en-ciel .ux-demo-easter-egg__erreur {
    color: #71354D;
    font-size: 13px;
    margin: 10px 0 0;
  }
  .ux-portail--arc-en-ciel .ux-demo-easter-egg__erreur:empty { display: none; }
  .ux-portail--arc-en-ciel .ux-demo-easter-egg__retour {
    background: #FFFDFB;
    border: 1px solid #806391;
    color: #43235D;
    font-size: 13px;
    min-height: 44px;
    max-width: 100%;
    flex-shrink: 0;
  }
  .ux-portail--arc-en-ciel .ux-demo-easter-egg__retour:hover:not(:disabled) {
    background: #F5ECFF;
    border-color: #4B2377;
  }
  @media (max-width: 600px) {
    .ux-portail--arc-en-ciel .ux-demo-easter-egg { padding: 18px; gap: 14px; }
    .ux-portail--arc-en-ciel .ux-demo-easter-egg__texte { flex-basis: 100%; }
    .ux-portail--arc-en-ciel .ux-demo-easter-egg__retour { width: 100%; }
    .ux-portail--arc-en-ciel .ux-resume .admin__stat { padding: 12px; }
  }
}
@media print {
  .ux-demo-easter-egg { display: none; }
}
`
